function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconLikeRexFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 14H2v16h3a2 2 0 002-2V16a2 2 0 00-2-2zM28 14h-9s2-6 2-8V3.5A1.5 1.5 0 0019.5 2H19c-.529 0-1 1-1 1l-2 4-6.414 6.414A2 2 0 009 14.828V26a4 4 0 004 4h10.172a2 2 0 001.414-.586l4.828-4.828A2 2 0 0030 23.172V16a2 2 0 00-2-2z",
    fill: props.color
  }));
}

export default SvgIconLikeRexFilled;